export default __webpack_public_path__ + "static/media/step_7_choose_container_type.c95e0505.png";